var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"mt-4 pl-2"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',[_vm._v("Пользователи")])]),_c('users-table')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }